import { render, staticRenderFns } from "./SegmentTabs.vue?vue&type=template&id=c06a1f78&scoped=true&"
import script from "./SegmentTabs.vue?vue&type=script&lang=js&"
export * from "./SegmentTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06a1f78",
  null
  
)

export default component.exports